// src/components/documents/LineTaxPicker.js — taxlines5-a4c81e37 (tax codes on every line, Stage S5)
//
// One line's Tax box when the company's Settings › Taxes switch is ON (documentLineTax.js): the estimate
// page's (S4) and the older pop-ups' (S5). People who pick tax (office roles, Sales Consultants) get one
// dropdown — the company's codes or its QuickBooks codes, plus "No tax"; a stopped code has an amber
// border and its note; "No tax" is light amber. Anyone else sees the line's tax as text. The caller
// passes its own field classes, so the box looks like the editor it sits in.
//
// FieldTaxChip: "Added in the field — check tax" on a technician's line, for office roles.
import React from 'react';
import { linePicker, applyLinePick, fieldTaxCheckOf, FIELD_TAX_CHECK_TEXT } from '../../utils/documentLineTax';

export default function LineTaxPicker({
    line, ctx, taxCtx, canPick, onPick, id, srLabel, disabled,
    selectClassName = '', selectStyle, textClassName = '', noteClassName = 'block mt-1 text-xs text-amber-700',
}) {
    const pick = linePicker(line, ctx, taxCtx);
    const chosen = pick.choices.find((c) => c.value === pick.value) || {};
    return (
        <>
            {canPick ? (
                <>
                    <label htmlFor={id} className="sr-only">{srLabel}</label>
                    <select id={id} value={pick.value} disabled={disabled} onChange={(e) => onPick(applyLinePick(line, e.target.value, ctx))}
                        title={chosen.title}
                        style={selectStyle} className={`${selectClassName} ${pick.exempt ? '!bg-amber-50' : ''} ${pick.stopped ? '!border-amber-400 !border-2' : ''}`}>
                        {pick.choices.map((c) => <option key={c.value || 'default'} value={c.value} title={c.title}>{c.label}</option>)}
                    </select>
                </>
            ) : (
                <span className={textClassName}>{chosen.label || ''}</span>
            )}
            {pick.note && <span className={noteClassName}>{pick.note}</span>}
        </>
    );
}

/** The marker chip, or null when the line has none / this person isn't an office role. */
export function FieldTaxChip({ line, show, className = 'self-start' }) {
    if (!show || !fieldTaxCheckOf(line)) return null;
    return <span className={`${className} px-2 py-0.5 rounded-full bg-amber-50 border border-amber-200 text-xs font-semibold text-amber-800`}>{FIELD_TAX_CHECK_TEXT}</span>;
}

/** The amber "Saving will change the tax on this … from $X to $Y." note, or null. */
export function TaxChangeNote({ text, className = '' }) {
    if (!text) return null;
    return <p role="status" className={`p-3 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-800 ${className}`}>{text}</p>;
}
